import React, { Component } from 'react';

import arrowUp from '../../../../assets/icons/arrow-up-footer.svg';
import arrowUpGrey from '../../../../assets/icons/arrow-up-grey.svg';
import arrowDownGrey from '../../../../assets/icons/arrow-down-grey.svg';
import { footerLinks, copy, appLinks, logos, copyright, banner } from '../DefaultFooter/footerLinks';

export class MobileFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      helpExpanded: true,
      termsAndPrivacyExpanded: false,
      joinUsExpanded: false,
      findUsExpanded: false,
      ourProductsExpanded: false
    };
  }

  toggleHelp() {
    this.setState(prevState => {
      const { helpExpanded, termsAndPrivacyExpanded, joinUsExpanded, findUsExpanded, ourProductsExpanded } = prevState;
      return {
        helpExpanded: !helpExpanded,
        termsAndPrivacyExpanded,
        joinUsExpanded,
        findUsExpanded,
        ourProductsExpanded
      };
    });
  }

  toggleTermsAndPrivacy() {
    this.setState(prevState => {
      const { helpExpanded, termsAndPrivacyExpanded, joinUsExpanded, findUsExpanded, ourProductsExpanded } = prevState;
      return {
        helpExpanded,
        termsAndPrivacyExpanded: !termsAndPrivacyExpanded,
        joinUsExpanded,
        findUsExpanded,
        ourProductsExpanded
      };
    });
  }

  toggleJoinUs() {
    this.setState(prevState => {
      const { helpExpanded, termsAndPrivacyExpanded, joinUsExpanded, findUsExpanded, ourProductsExpanded } = prevState;
      return {
        helpExpanded,
        termsAndPrivacyExpanded,
        joinUsExpanded: !joinUsExpanded,
        findUsExpanded,
        ourProductsExpanded
      };
    });
  }

  toggleFindUs() {
    this.setState(prevState => {
      const { helpExpanded, termsAndPrivacyExpanded, joinUsExpanded, findUsExpanded, ourProductsExpanded } = prevState;
      return {
        helpExpanded,
        termsAndPrivacyExpanded,
        joinUsExpanded,
        findUsExpanded: !findUsExpanded,
        ourProductsExpanded
      };
    });
  }

  toggleOurProducts() {
    this.setState(prevState => {
      const { helpExpanded, termsAndPrivacyExpanded, joinUsExpanded, findUsExpanded, ourProductsExpanded } = prevState;
      return {
        helpExpanded,
        termsAndPrivacyExpanded,
        joinUsExpanded,
        findUsExpanded,
        ourProductsExpanded: !ourProductsExpanded
      };
    });
  }

  toggleExpanded(title) {
    switch (title) {
      case 'Help':
        this.toggleHelp();
        break;
      case 'Terms & Privacy':
        this.toggleTermsAndPrivacy();
        break;
      case 'Join Us':
        this.toggleJoinUs();
        break;
      case 'Find Us':
        this.toggleFindUs();
        break;
      case 'Our Products':
        this.toggleOurProducts();
        break;
      default:
        break;
    }
  }

  scrollUp = () => {
    document.getElementById('page-main').scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  getExpanded(title) {
    switch (title) {
      case 'Help':
        return this.state.helpExpanded;
      case 'Terms & Privacy':
        return this.state.termsAndPrivacyExpanded;
      case 'Join Us':
        return this.state.joinUsExpanded;
      case 'Find Us':
        return this.state.findUsExpanded;
      case 'Our Products':
        return this.state.ourProductsExpanded;
      default:
        return false;
    }
  }

  render() {
    return (
      <div>
        <div className="default-footer mobile-footer" data-test-id="mobile-footer">
          <div className="mobile-footer-scroll" onClick={this.scrollUp.bind(this)}>
            <img src={arrowUp} className="mobile-arrow" />
            Back to top
          </div>
          {footerLinks.map((category, index) => {
            const { title } = category;
            return (
              <div key={index} className="footer-link mobile-footer-link" data-test-id={`mobile-footer-${index.toString()}`}>
                <div className="footer-link-title mobile-footer-link-title" onClick={this.toggleExpanded.bind(this, title)} data-test-id={`mobile-footer-${index.toString()}-title`}>
                  {title}
                  <img src={this.getExpanded(title) ? arrowUpGrey : arrowDownGrey} className="footer-arrow-down" />
                </div>
                <div className="footer-divider footer-divider-gap" />
                {this.getExpanded(title) && (
                  category.links.map((link, i) => {
                    const { url, text } = link;
                    return (
                      <a key={i} href={url} target="_blank" rel="noopener noreferrer" className="footer-link-text">{text}</a>
                    );
                  })
                )}
              </div>
            );
          })}
          <div className="mobile-footer-apps">Our Apps</div>
          {appLinks(true)}
          <div className="footer-divider" />
          {copy}
          <div className="footer-divider" />
          {logos(true)}
          <div className="footer-divider" />
          {copyright}
        </div>
        {banner}
      </div>
    );
  }
}

export default MobileFooter;
